@if (location$ | async) {
  <agr-page-toolbar
    class="overview-v2__toolbar"
    [stickyToolbar]="true"
    [stickyDetails]="true"
    [pageTitle]="
      location
        ? ('order' | switchTranslation) +
          ' ' +
          location.name +
          ', ' +
          location.street +
          (location.houseNumber ? ' ' + location.houseNumber : '') +
          ', ' +
          location.city
        : ''
    "
    [isEmpty]="!location || !hasOrderPlan"
    [emptyTitle]="
      !!location ? (areAnyCropFieldsLinked === true ? ('noRequisite' | switchTranslation) : ('linkCropFields' | translate)) : ('selectLocation' | translate)
    "
    [emptyDescription]="
      !!location
        ? areAnyCropFieldsLinked === true
          ? ('noRequisiteDescription' | switchTranslation)
          : ('noLinkedCropFields' | translate)
        : ('noLocationSelected' | translate)
    "
    [showEmptyAction]="true"
    [emptyActionText]="
      !!location ? (areAnyCropFieldsLinked === true ? ('fieldAdvice' | translate) : ('linkCropFields' | translate)) : ('selectLocation' | translate)
    "
    emptyActionIcon="navigate_next"
    emptyActionColor="accent"
    (emptyAction)="doEmptyAction()"
    [hasPrimaryAction]="!!location"
    primaryActionIcon="shopping_cart"
    [primaryActionText]="'toOrder' | switchTranslation"
    (primaryAction)="confirmOrder()"
    [hasSecondaryAction]="!!location"
    secondaryActionIcon="add"
    [secondaryActionText]="'addProduct' | translate"
    (secondaryAction)="addOrderLine()"
    [buttonItems]="buttonItems"
    (buttonAction)="buttonAction($event)"
  >
    <div displayAlways class="layout--margin-top wrapper--spacing-horizontal">
      <agr-filter [config]="filterConfig"></agr-filter>
      @if (areAnyCropFieldsNotLinked === true) {
        <div class="notification notification-warning" data-test="overview-spray-license-warning">
          <mat-icon>warning</mat-icon>
          {{ 'notLinkedCropFields' | translate }}
        </div>
      }
      @if (orderplanOptimized$ | async) {
        <div class="notification notification-success" data-test="overview-optimization-success">
          <mat-icon>done</mat-icon>
          {{ 'orderplanOptimizedSuccess' | translate }}
        </div>
      }
    </div>
    @if (isTableVisible$ | async) {
      <app-order-planning-table
        data-test="order-planning-overview__table"
        [columnsToDisplay]="columnsToDisplay"
        [dynamicPeriodsColumns]="dynamicPeriodsColumns"
      ></app-order-planning-table>
    }
  </agr-page-toolbar>
}
